import { createFileRoute, redirect } from '@tanstack/react-router'
import { useAuthStore } from '../../../stores/authStore'
import { EntityConfigPage } from '../../../features/admin/EntityConfigPage'

/* Route Definition */

export const Route = createFileRoute('/_authenticated/admin/entity-config')({
  beforeLoad: () => {
    const role = useAuthStore.getState().user?.role
    if (role !== 'admin') {
      throw redirect({ to: '/admin' })
    }
  },
  component: AdminEntityConfigRoute,
})

/* Route Component */

function AdminEntityConfigRoute() {
  return <EntityConfigPage />
}
